import { StyledContent } from '@/components/styles';
import { Picture } from '@/components';
import Swiper from 'react-id-swiper';
import vars from '@/assets/styles/vars';

const TitleContentBeforeAfter = ({ data }) => {
  const { content: htmlContent, images: imagesFromProps } = data;
  const images = imagesFromProps || [];

  const params = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    preloadImages: true,
    resistanceRatio: 0,
    watchOverflow: true,
    speed: 600,
    autoHeight: false,
    preventInteractionOnTransition: true,
    spaceBetween: 20,
    updateOnWindowResize: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      601: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      }
    }
  };

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </StyledContent.Description>
      )}

      {!!images?.length && (
        <StyledContent.BeforeAfter>
          <Swiper {...params}>
            {images.map((image, ind) => {
              return (
                <StyledContent.BeforeAfterSlide>
                  <Picture {...image} />
                  {ind % 2 == 0 && <StyledContent.Html dangerouslySetInnerHTML={{ __html: '<h6>BEFORE</h6>' }} />}
                  {ind % 2 !== 0 && <StyledContent.Html dangerouslySetInnerHTML={{ __html: '<h6>AFTER</h6>' }} />}
                </StyledContent.BeforeAfterSlide>
              );
            })}
          </Swiper>
        </StyledContent.BeforeAfter>
      )}
    </>
  );
};

export default TitleContentBeforeAfter;
